//This is made as fallback to iPhone/iPads private browsing
//Checks if users browser supports localstorage, if not use cookies

import angular from 'angular';

angular.module('folkeuni').factory('DataStorage', function ($q) {
    var dataStorage = this;

    function lsTest(){
        var test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch(e) {
            return false;
        }
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    dataStorage.get = function (key) {
        var deferred = $q.defer();
        if (lsTest() === true) {
            if (localStorage.getItem(key) !== null) {
                deferred.resolve(localStorage.getItem(key));
            }
            else {
                deferred.reject("No key match in localstorage");
            }
        }
        else {
            if(getCookie(key) != ""){  
               deferred.resolve(getCookie(key));
            }
            else{
                deferred.reject("No key match in localstorage");                
            }
        }
        return deferred.promise;
    }

    dataStorage.set = function (key, data) {
        var deferred = $q.defer();
       
        if (lsTest() === true) {
            localStorage.setItem(key, data);      
            deferred.resolve("Localstorage saved");      
        }
        else{
            setCookie(key, data, 365);
          
            deferred.resolve("Cookie saved");      
        }
        
        return deferred.promise;
    }

    return dataStorage
});